import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css'; // Assuming legal-page styles are here

const TermsConditionsPage = () => {
  return (
    <div className="legal-page">
      <div className="back-link-container">
        <Link to="/" className="back-link">← Back to Home</Link>
      </div>
      <h1>Terms & Conditions</h1>
      <p><strong>Last Updated: [Date]</strong></p>

      <p>
        Please read these Terms and Conditions ("Terms", "Terms and Conditions") 
        carefully before using the [Your Website URL] website and the Magical Videos 
        service (the "Service") operated by [Your Company Name] ("us", "we", or "our").
      </p>
      <p>
        Your access to and use of the Service is conditioned on your acceptance of 
        and compliance with these Terms. These Terms apply to all visitors, users 
        and others who access or use the Service.
      </p>

      <h2>Accounts</h2>
      <p>
        When you create an account with us, you must provide us information that is 
        accurate, complete, and current at all times. Failure to do so constitutes 
        a breach of the Terms, which may result in immediate termination of your 
        account on our Service.
      </p>

      <h2>Intellectual Property</h2>
      <p>
        The Service and its original content, features and functionality are and 
        will remain the exclusive property of [Your Company Name] and its licensors. ...
      </p>

      {/* Add more sections as required: User Content, Prohibited Uses, Termination, Disclaimer, Governing Law, Changes, Contact, etc. */}
      <h2>Contact Us</h2>
      <p>
        If you have any questions about these Terms, please contact us at: 
        [Your Contact Email/Info]
      </p>
    </div>
  );
};

export default TermsConditionsPage; 